export * from './Page';



// WEBPACK FOOTER //
// ./src/common/components/layout/Page/index.tsx